/* eslint-disable react/prop-types */
import React from "react";
import { InputAdornment } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";

function FormInput({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "",
  disabled = false,
  required = false,
  startIcon = null,
  endIcon = null,
  helperText = "",
  error = false,
}) {
  return (
    <ArgonBox mb={2}>
      {label && (
        <ArgonTypography variant="caption" fontWeight="bold" mb={0.5} display="block">
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </ArgonTypography>
      )}
      <ArgonInput
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        size="medium"
        error={error}
        startAdornment={startIcon ? <InputAdornment position="start">{startIcon}</InputAdornment> : null}
        endAdornment={endIcon ? <InputAdornment position="end">{endIcon}</InputAdornment> : null}
        sx={{
          width: "100%",
          minHeight: 48,
          px: 2,
          "& input": {
            overflowX: "auto",
            whiteSpace: "nowrap",
            textOverflow: "clip",
          },
        }}
      />
      {helperText && (
        <ArgonTypography variant="caption" color={error ? "error" : "text"} mt={0.5} display="block">
          {helperText}
        </ArgonTypography>
      )}
    </ArgonBox>
  );
}

export default FormInput;
